import { useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { useTranslation } from '../../TranslationContext';

export const Hero = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);
  const { t } = useTranslation();

  const handleVolumeToggle = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 transition-all duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="relative z-10 space-y-8">
            <div>
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-gray-900 dark:text-white">
                <span className="block">{t('title_part1')}</span>
                <span className="block mt-2 bg-gradient-to-r from-pink-700 to-gray-400 bg-clip-text text-transparent">
                  {t('title_part2')}
                </span>
              </h1>
              <p className="mt-6 text-lg sm:text-xl text-gray-600 dark:text-gray-300 max-w-2xl">
                {t('description')}
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="/BecomeClient"
                className="inline-flex items-center justify-center px-8 py-3 text-base font-medium rounded-lg text-white bg-gray-600 hover:bg-gray-800 dark:bg-gray-400 dark:hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                {t('button')}
              </a>
            </div>
          </div>

          {/* Right Column - Video Section */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden border-4 border-white dark:border-gray-800 shadow-2xl bg-white dark:bg-gray-800">
              <div className="aspect-video relative">
                <video
                  ref={videoRef}
                  className="w-full h-full object-cover"
                  controls
                  playsInline
                  autoPlay
                  muted
                >
                  <source src="/demo.mp4" type="video/mp4" />
                  {t('video_error')}
                </video>

                <button
                  onClick={handleVolumeToggle}
                  className="absolute bottom-4 right-4 bg-black/50 p-2 rounded-full hover:bg-black/70 transition-all duration-200 z-30"
                >
                  {isMuted ? (
                    <VolumeX className="w-5 h-5 text-white" />
                  ) : (
                    <Volume2 className="w-5 h-5 text-white" />
                  )}
                </button>
              </div>
              
              {/* Video Description */}
              <div className="p-4 border-t border-gray-200 dark:border-gray-700">
                <h3 className="font-medium text-gray-900 dark:text-white">
                  {t('video_title')}
                </h3>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  {t('video_description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;

// import { useRef, useState } from 'react';
// import { Volume2, VolumeX, } from 'lucide-react';

// export const Hero = () => {
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const [isMuted, setIsMuted] = useState(true);

//   const handleVolumeToggle = () => {
//     if (videoRef.current) {
//       videoRef.current.muted = !videoRef.current.muted;
//       setIsMuted(!isMuted);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 transition-all duration-200">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//         <div className="grid lg:grid-cols-2 gap-12 items-center">
//           {/* Left Column - Text Content */}
//           <div className="relative z-10 space-y-8">
//             <div>
//               <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-gray-900 dark:text-white">
//                 <span className="block">Secure Authentication</span>
//                 <span className="block mt-2 bg-gradient-to-r from-pink-700 to-gray-400 bg-clip-text text-transparent">
//                   for Modern Businesses
//                 </span>
//               </h1>
//               <p className="mt-6 text-lg sm:text-xl text-gray-600 dark:text-gray-300 max-w-2xl">
//                 Otenti provides enterprise-grade authentication services that help you secure your applications and manage user access effectively.
//               </p>
//             </div>
            
//             <div className="flex flex-col sm:flex-row gap-4">
//               <a
//                 href="/BecomeClient"
//                 className="inline-flex items-center justify-center px-8 py-3 text-base font-medium rounded-lg text-white bg-gray-600 hover:bg-gray-800 dark:bg-gray-400 dark:hover:bg-gray-800 transition-all duration-200 shadow-lg hover:shadow-xl"
//               >
//                 Get Started
//               </a>
//             </div>
//           </div>

//           {/* Right Column - Video Section */}
//           <div className="relative">
//             <div className="rounded-2xl overflow-hidden border-4 border-white dark:border-gray-800 shadow-2xl bg-white dark:bg-gray-800">
//               <div className="aspect-video relative">
//                 <video
//                   ref={videoRef}
//                   className="w-full h-full object-cover"
//                   controls
//                   playsInline
//                   autoPlay
//                   muted
//                 >
//                   <source src="/demo.mp4" type="video/mp4" />
//                   Your Browser can't read this video
//                 </video>

//                 <button
//                   onClick={handleVolumeToggle}
//                   className="absolute bottom-4 right-4 bg-black/50 p-2 rounded-full hover:bg-black/70 transition-all duration-200 z-30"
//                 >
//                   {isMuted ? (
//                     <VolumeX className="w-5 h-5 text-white" />
//                   ) : (
//                     <Volume2 className="w-5 h-5 text-white" />
//                   )}
//                 </button>
//               </div>
              
//               {/* Video Description */}
//               <div className="p-4 border-t border-gray-200 dark:border-gray-700">
//                 <h3 className="font-medium text-gray-900 dark:text-white">
//                   Otenti Demo
//                 </h3>
//                 <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
//                   Watch how easily you can integrate our secure authentication system into your application.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Hero;

